export const CTypeContacts = {
    ACCOUNT_BANK: 'ACCOUNT_BANK',
    DEBIT_CARD: 'DEBIT_CARD',
    INTRABANK:'INTRABANK',
    ORPHAN: 'ORPHAN'
  } as const

export type typeContactsLinked = typeof CTypeContacts[keyof typeof CTypeContacts]